import { Field } from 'redux-form'
import { AddRequiredValidation } from '../'

export const BasicInput = ({ input, disabled, label, type, checked = false, className, style = null }) => {
  return (
    <div className={`${type} ${disabled ? 'disabled': ''} ${className || ''}`} style={style}>
      <label htmlFor={`${input.name}-${input.value}`}>
        <input {...input}
          type={type}
          className={`cb-${type}`}
          id={`${input.name}-${input.value}`}
          aria-label={label}
          disabled={disabled}
          checked={checked}
        />
        <span className="cb-span" />
        {label}
      </label>
    </div>
  )
}

export default props => <Field {...props}
  component={BasicInput}
  validate={AddRequiredValidation(props.isRequired, props.validate, props.checkboxRequired)}
  normalize={props.normalize}
/>
